import { Component, OnInit, ViewChild, TemplateRef, OnDestroy, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseService, ErrorService, LanguageService } from '@shared/services';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { finalize, first, takeUntil } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-new-user-grid-configration',
  templateUrl: './new-user-grid-configration.component.html',
  styleUrls: ['./new-user-grid-configration.component.scss']
})
export class NewUserGridConfigrationComponent implements OnInit, OnDestroy {
    private _unsubscribeAll$ = new Subject<boolean>();
    @Input() showDialog: boolean = false;
     @Input() IsUserGrid: boolean = false;
    // subscription: Subscription = new Subscription();
    items: MenuItem[];
    sub: any;
    Grid: any;
    constructor(
        private translate: TranslateService,
        public router: Router,
        public route: ActivatedRoute,
        private modalService: BsModalService,
        private BaseService: BaseService,
        private fb: FormBuilder,
        private _errorService: ErrorService,
        private _langService: LanguageService
    ) {
        this.sub = this.route.params.pipe(takeUntil(this._unsubscribeAll$)).subscribe((params) => {});
    }

    searchValue = '';
    changeNewContant = false;
    laddaSearchProgress: boolean | number = false;

    @Input('GridData')
    GridData: any;

    SupplementCategoriesList = [];
    EntityForm: FormGroup;
    private initForm(): void {
        //   var id = Guid.create();
        this.EntityForm = this.fb.group({
            windowRoute: new FormControl(null, [Validators.required]),
            grid: new FormControl(null, [Validators.required]),
            col: new FormControl(null, [Validators.required]),
            colOrder: new FormControl(null, [Validators.required]),
            isShowen: new FormControl(true, [Validators.required])
        });
    }
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    displayedColumns: string[] = ['handle', 'show', 'col'];
    dataSource = new MatTableDataSource([]);
    selection = new SelectionModel(true, []);

    formType = 'add';
    isBusy = false;
    saveContant = false;
    onDrop(event: CdkDragDrop<any[]>) {
  const prevIndex = event.previousIndex;
  const newIndex = event.currentIndex;
  if (prevIndex === 0 || newIndex === 0) return;

  const data = this.dataSource.data;
  moveItemInArray(data, prevIndex, newIndex);
  this.reorderData();
}

moveUp(index: number): void {
  if (index <= 0) return; // only block first row
  const data = this.dataSource.data;
  moveItemInArray(data, index, index - 1);
  this.reorderData();
}


moveDown(index: number): void {
  if (index >= this.dataSource.data.length - 1) return;
  const data = this.dataSource.data;
  moveItemInArray(data, index, index + 1);
  this.reorderData();
}

private reorderData(): void {
  const updatedData = this.dataSource.data.map((item, idx) => ({
    ...item,
    colOrder: idx + 1
  }));
  this.dataSource = new MatTableDataSource(updatedData);
}

    saveAddEdit() {
        this.laddaSearchProgress = 1;
        const controls = this.EntityForm.controls;
        Object.keys(controls).forEach((key) => {
            controls[key].markAsTouched();
        });

        this.saveContant = false;
        
        // Prepare data for saving with proper column ordering
        let dataToSave = [...this.dataSource.data];
        
        if (this.IsUserGrid) {
            // For user grid, ensure select column is included and properly ordered
            const selectCol = {
                col: 'select',
                colDisplayName: 'Select',
                colOrder: 1,
                isShowen: true,
                windowRoute: this.GridData.windowRoute,
                grid: this.GridData.grid
            };
            
            // Reorder other columns to start from 2
            const otherCols = dataToSave.map((item, index) => ({
                ...item,
                colOrder: index + 2
            }));
            
            // Combine select column with other columns
            dataToSave = [selectCol, ...otherCols];
        } else {
            // For regular grid, use existing logic
            const columns = dataToSave;
            
            // Step 1: Separate "select" column
            const selectCol = columns.find(col => col.col === 'select');
            const otherCols = columns.filter(col => col.col !== 'select');
            
            // Step 2: Sort other columns by current order
            otherCols.sort((a, b) => a.colOrder - b.colOrder);
            
            // Step 3: Reassign colOrder
            if (selectCol) {
                selectCol.colOrder = 1;
            }
            
            otherCols.forEach((col, index) => {
                col.colOrder = index + 2; // Start from 2
            });
            
            // Rebuild the full list in correct order
            dataToSave = selectCol ? [selectCol, ...otherCols] : [...otherCols];
        }
        
        console.log('Data to save:', dataToSave);


        if(!this.IsUserGrid){
            this.BaseService.post('GridConfig/newEditGridConfig', dataToSave)
            .pipe(
                takeUntil(this._unsubscribeAll$),
                first(),
                finalize(() => (this.laddaSearchProgress = false))
            )
            .subscribe(
                (result) => {
                    if (result.isSuccess) {
                      this.closeModal();
                        // const dgwData = result.data;
                        this.newMessage(4, '');
                        this.changeNewContant = false;
                        //this.closeAddEditModal();
                        this.showDialog=false;
                        this.GetAllCol();
                    } else {
                        this.newMessage(77, '');
                    }
                },
                (error) => {
                    this.laddaSearchProgress = false;
                }
            );
        }
        else{
            this.BaseService.post('GridConfig/editUserGridConfig', dataToSave)
            .pipe(
                takeUntil(this._unsubscribeAll$),
                first(),
                finalize(() => (this.laddaSearchProgress = false))
            )
            .subscribe(
                (result) => {
                    if (result.isSuccess) {
                      this.closeModal();
                        // const dgwData = result.data;
                        this.newMessage(4, '');
                        this.changeNewContant = false;
                        //this.closeAddEditModal();
                        this.showDialog=false;
                        this.GetAllCol();
                    } else {
                        this.newMessage(77, '');
                    }
                },
                (error) => {
                    this.laddaSearchProgress = false;
                }
            );
        }
        

        // this.modalRef.hide();
    }
    ngOnDestroy() {
        this._unsubscribeAll$.next(true);
        this._unsubscribeAll$.complete();
        // this.subscription.unsubscribe();
    }
    @ViewChild('formAddEditModal', { static: true }) formModal: TemplateRef<any>;
    modalRef: BsModalRef | null;
    // openModal() {
    //     const configs = {
    //         keyboard: false,
    //         ignoreBackdropClick: true,
    //         // class: ' modal-lg modal-primary commenModel ModelLayoutWithTabs animated fadeInRight',
    //         class: ' ModelLayout3 commenModel modal-dialog  modal-primary animated fadeInRight',
    //         animated: false
    //     };

    //     this.modalRef = this.modalService.show(this.formModal, configs);
    // }
    closeAddEditModal() {
        if (!this.changeNewContant) {
            this.ClosePopup();
        } else this.newMessage(144, 'ClosePopup');
    }
    ClosePopup() {
        this.modalRef.hide();
        this.changeNewContant = false;
    }

    Edit(row) {
        this.formType = 'edit';
        const controls = this.EntityForm.controls;
        Object.keys(controls).forEach((key) => {
            if (row[key] != null) {
                this.EntityForm.get(key).setValue(row[key]);
            }
        });
        this.openModal();
    }
    AddNewItem() {
        this.formType = 'add';
        this.initForm();
        this.EntityForm.get('grid').setValue(this.GridData.grid);
        this.EntityForm.get('windowRoute').setValue(this.GridData.windowRoute);

        this.openModal();
    }

    deleteSelected() {
        if (this.selection.selected.length == 0) {
            this.newMessage(60, 'error');
        } else {
            this.newMessage(9, 'delete');
        }
    }
    setCheckboxValue(event, atrr) {
        this.changeNewContant = true;

        if (event.checked) this.EntityForm.get(atrr).setValue(true);
        else {
            this.EntityForm.get(atrr).setValue(false);
        }
    }

    ngOnInit() {
        this.initForm();
        this.items = [
            {
                label: this.translate.instant('Delete'),
                icon: 'pi pi-times',
                command: () => {
                    this.deleteSelected();
                }
            }
        ];

        //this.GetAllCol();

        this._errorService.currentAction
            .pipe(takeUntil(this._unsubscribeAll$))
            .subscribe((action) => this.actionMsg(action));
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    checkboxLabel(row): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.email + 1}`;
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    // delete() {
    //     // console.log(this.selectedcapacity.map(obj => obj.unitid));
    //     this._Supplementservice
    //         .DeleteProviderList(this.selection.selected)
    //         .pipe(takeUntil(this._unsubscribeAll$), first())
    //         .subscribe(
    //             (result) => {
    //                 if (result) {
    //                     this.newMessage(54, '');
    //                 } else {
    //                     this.newMessage(55, '');
    //                 }
    //                 this.selection = new SelectionModel(true, []);
    //                 this.GetAllProvider();
    //                 this.laddaSearchProgress = false;
    //                 this.changeNewContant = false;
    //                 this.saveContant = false;
    //             },
    //             (error) => {
    //                 this.laddaSearchProgress = false;
    //             }
    //         );
    // }

    changeStatus(data) {}

    actionMsg(data) {
        if (data !== '') {
            this[data]();
            this._errorService.action('');
        }
    }
    newMessage(id, action) {
        this._errorService.changeMessage({ id: id, action: action });
    }
    closeLocalizationPopup(localizationComponant) {
        localizationComponant.closeAddEditModal();
    }
    @Output('newCol')
    newCol: EventEmitter<any> = new EventEmitter<any>();
    @Output('close')
    close: EventEmitter<any> = new EventEmitter<any>();
    GetAllCol(): void {
        this.searchValue = '';
        this.isBusy = true;
        if(!this.IsUserGrid){
            this.BaseService.post(`GridConfig/GetGridCongif`, this.GridData)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                console.log('Regular Grid Data:', result.data);
                const filteredData = result.data.filter((item) => item.col !== 'select');
                this.dataSource = new MatTableDataSource(filteredData);
                this.dataSource.sort = this.sort;
                this.newCol.emit(result.data);
                this.isBusy = false;
            });
        }
        else{
            this.BaseService.post(`GridConfig/GetGridConfigShowen`, this.GridData)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                console.log('User Grid Data:', result.data);
                
                // Check if the data needs to be normalized for user grid
                let processedData = result.data;
                
                // If user grid doesn't have select column, we need to add it and reorder
                const hasSelectColumn = processedData.some(item => item.col === 'select');
                
                if (!hasSelectColumn) {
                    // Add select column as first item if it doesn't exist
                    const selectColumn = {
                        col: 'select',
                        colDisplayName: 'Select',
                        colOrder: 1,
                        isShowen: true,
                        windowRoute: this.GridData.windowRoute,
                        grid: this.GridData.grid
                    };
                    
                    // Reorder existing columns to start from 2
                    processedData = processedData.map((item, index) => ({
                        ...item,
                        colOrder: index + 2
                    }));
                    
                    // Sort by colOrder to maintain proper order
                    processedData.sort((a, b) => a.colOrder - b.colOrder);
                    
                    // Add select column at the beginning
                    processedData = [selectColumn, ...processedData];
                }
                
                console.log('Processed User Grid Data:', processedData);
                
                // Filter out select column for display (but keep it in emitted data)
                const filteredData = processedData.filter((item) => item.col !== 'select');
                this.dataSource = new MatTableDataSource(filteredData);
                this.dataSource.sort = this.sort;
                
                // Emit the full data including select column with proper ordering
                this.newCol.emit(processedData);
                this.isBusy = false;
            });
        }
        
    }

    ngOnChanges(changes: SimpleChanges): void {
  if (changes['showDialog']) {
    if (this.showDialog) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }
}

    @ViewChild('ListConfigration', { static: true }) ListConfigration: TemplateRef<any>;

    openModal() : void {
        //debugger

        this.initForm();
        this.items = [
            {
                label: this.translate.instant('Delete'),
                icon: 'pi pi-times',
                command: () => {
                    this.deleteSelected();
                }
            }
        ];

        this.GetAllCol();

        this._errorService.currentAction
            .pipe(takeUntil(this._unsubscribeAll$))
            .subscribe((action) => this.actionMsg(action));
      
      const configs = {
              keyboard: false,
              ignoreBackdropClick: true,
              class: ' modal-lg modal-primary  ModelPopUpLayoutFilterPopUps commenModel  fadeInCenter',
              animated: false
          };
          this.modalRef = this.modalService.show(this.ListConfigration, configs);
        
      }

      closeModal(): void {
  if (this.modalRef) {
    this.modalRef.hide();
    this.modalRef = null;
  }
  this.close.emit();
  
}
}
